import { HStack, Link, LinkBox, LinkOverlay } from "@chakra-ui/react";
import * as React from "react";
import { NavLink as RouterLink, useMatch } from "react-router-dom";

interface NavItemProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  href?: string;
  to?: string;
  end?: boolean;
}

export default function NavItem({
  children,
  end,
  href,
  icon,
  to,
}: NavItemProps) {
  const match = useMatch(to || href);
  const label = (
    <HStack>
      {icon}
      {children}
    </HStack>
  );
  const link =
    href === undefined ? (
      <RouterLink {...{ end, to }}>{label}</RouterLink>
    ) : (
      <Link
        color="colorPalette.contrast/80"
        href={href}
        _hover={{ textDecoration: "none" }}
      >
        {label}
      </Link>
    );

  return (
    <LinkBox
      borderRadius="sm"
      borderColor="transparent"
      borderWidth="1"
      px="2"
      py="1"
      bg={match === null ? "transparent" : "colorPalette.contrast/10"}
      _hover={{
        background: "colorPalette.contrast/10",
        borderColor: "colorPalette.contrast/15",
        color: "colorPalette.contrast",
      }}
      transition="all"
    >
      <LinkOverlay color="colorPalette.contrast/80" asChild fontSize="sm">
        {link}
      </LinkOverlay>
    </LinkBox>
  );
}
